//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    clearable: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    hideDetails: { type: Boolean, default: false },
    value: { type: [String, Number], default: '' },
    label: { type: String, default: '' },
    type: { type: String, default: 'text' },
    width: { type: String, default: '' },
    suffix: { type: String, default: '' },
    halfOpacitySuffix: { type: Boolean, default: false },
    notNull: { type: Boolean, default: false },
    notZero: { type: Boolean, default: false },
  },

  computed: {
    style() {
      return {
        width: this.width,
      };
    },

    getValidationRules() {
      const rules = [];

      if (this.$props.notNull) {
        rules.push((value) => !!value || this.$t('This field must be filled'));
      }

      if (this.$props.notZero) {
        rules.push((value) => value > 0 || this.$t('This field must be greater than 0'));
      }

      return rules;
    },
  },

  methods: {
    keydownHandler(event) {
      this.$emit('input', event.target.value);
      this.$emit('submit', event.target.value);
    },

    changeHandler(event) {
      this.$emit('input', event.target.value.trim());
    },
  },
};
